import React, { useState } from "react";
import UsersStyle from "./style";
import { Button, Col, Input, Row, Table, Form, Progress } from "antd";
import { SearchOutlined, LeftOutlined, DownloadOutlined } from "@ant-design/icons";
import styled from "styled-components";
import DevelopmentImg from "../../../../assets/Icons/development-img.png";
import { useNavigate } from "react-router-dom";
import COLORS from "../../../../common/Colors";
import Groups from "../../Groups"
import TabsList from "../../../Reusable/Tabs";

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

const StyledImg = styled.img`
  cursor: pointer;
`;

const ViewCourse = ({ tableViewData, setUserRenderView }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const navigate = useNavigate();
  const hanldeClickEdit = () => {};
  const columns1 = [
    {
      title: "Course",
      dataIndex: "course",
      key: "course",
      sorter: (a, b) => a.user - b.user,
    },
    {
      title: "Progress Status",
      dataIndex: "progressStatus",
      key: "progressStatus",
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
    },
    {
      title: "Enrolled on",
      dataIndex: "enrolledOn",
      key: "enrolledOn",
    },
    {
      title: "Completion Date",
      dataIndex: "completeDate",
      key: "completeDate",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    // {
    //   title: "",
    //   dataIndex: "edit",
    //   key: "edit",
    //   width: "7%",
    //   render: () => {
    //     return (
    //       <StyledImg
    //         src={EditIcon}
    //         alt="Download Icon"
    //         className="download-icon"
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           hanldeClickEdit();
    //         }}
    //       />
    //     );
    //   },
    // },
  ];

  const dataSource1 = [
    {
      key: 1,
      course: "What is TalentLibrary?",
      progressStatus: <Progress percent={50} showInfo={false} />,
      score: "-",
      enrolledOn: "17-10-2024",
      completeDate: "-",
      time: "-"
    },
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onChangeSortedTable = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const handleClickData = () => {
    setUserRenderView("view-table");
  };
  const items = [
    {
      id: "1",
      label: "Courses",
      component: <></>,
    },
    {
      id: "2",
      label: "Learning activities",
      component: <></>,
    },
    {
      id: "3",
      label: "Badges",
      component: <></>,
    },
    {
      id: "4",
      label: "Certificates",
      component: <></>,
    },
    {
      id: "5",
      label: "Timeline",
      component: <></>,
    },
  ];

  const CourserOverviewData = [
    {
        label: "Completion rate",
        value: "0.0%"
    },
    {
        label: "Completed courses",
        value: 0
    },
    {
        label: "Courses in progress",
        value: 0
    },
    {
        label: "Courses not passed",
        value: 0
    },
    {
        label: "Courses not started",
        value: 0
    },
    {
        label: "Training time",
        value: "0h 0m"
    },
  ]

  const TimelineData = [
    {
      timeline: "14 minutes ago",
      event: "You signed in",
    },
    {
      timeline: "19/10/2024",
      event: "You signed in",
    },
    {
      timeline: "18/10/2024",
      event: "You added yourself to the course New course via self enrollment",
    },
  ];

  const handleTabSelect = (key) => {
    setActiveTab(key);
  };

  const handleBack = () => {
    setUserRenderView("table-view");
  };
  return (
    <>
      <UsersStyle>
        <div className="user-title-container users-menu-filter-container">
          <div>
            <LeftOutlined onClick={handleBack} />{" "}
            <span className="user-menu-title">{tableViewData.user}</span>
          </div>
          {/* <Button onClick={() => navigate("/users/adduser")}>
            Edit Course
          </Button> */}
        </div>

        <TabsList
          items={items}
          handleTabSelect={handleTabSelect}
          activeKey={activeTab}
        />

        {(activeTab === "1" || activeTab === "2") && (
          <div className="course-overview-data-box">
            {CourserOverviewData.map((item, index) => {
              return(
                <div key={index}>
                    <p className="overview-value">{item.value}</p>
                    <p className="overview-label">{item.label}</p>
                </div>
              )
            })}
          </div>
        )}

        <br></br>

        {activeTab === "1" && (
          <>
            <Row className="users-menu-filter-container">
              <Col>
                <Form.Item name="search" className="search-input-field">
                  <Input prefix={<SearchOutlined />} placeholder="Search" />
                </Form.Item>
              </Col>

              {/* <Col>
                <Button>Enroll to Course</Button>
              </Col> */}
            </Row>
            <StyledTable
              // rowSelection={rowSelection}
              dataSource={dataSource1}
              columns={columns1}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "" : "non-white"
              }
              rowKey="checkin_id"
              id="Table"
              onChange={onChangeSortedTable}
              showSorterTooltip={{
                target: "sorter-icon",
              }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: () => {
                    handleClickData();
                  },
                };
              }}
            />
          </>
        )}

        {activeTab === "2" && (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
                width={340}
              />
              <div className="yet-designed-pages">
                <p className="developement-content">
                  There are no learning activities yet
                </p>
              </div>
            </Row>
          </>
        )}

        {activeTab === "3" && (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
                width={340}
              />
              <div className="yet-designed-pages">
                <p className="developement-content">
                  There are no certificates yet!
                </p>
              </div>
            </Row>
          </>
        )}

        {activeTab === "4" && (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
                width={340}
              />
              <div className="yet-designed-pages">
                <p className="developement-content">
                  There are no certificates yet!
                </p>
              </div>
            </Row>
          </>
        )}

        {activeTab === "5" && (
          <>
            <Row className="events_data_container">
              <div className="events_header_section">Event</div>
              <div className="events_data_box_container">
                {TimelineData.map((item, index) => {
                  return (
                    <div key={index} className="events_data_box">
                      <div className="event-backward-img-box">
                        <DownloadOutlined className="event-backward-img" />
                      </div>
                      <div>
                        <p className="creation-date">{item.timeline}</p>
                        <p className="event_name">{item.event}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Row>
          </>
        )}
      </UsersStyle>
    </>
  );
};

export default ViewCourse;
